import * as types from "./actionTypes";

export const getCorporatesRequest = () => ({
  type: types.GET_CORPORATES_REQUEST,
});

export const getCorporatesSuccess = (data) => ({
  type: types.GET_CORPORATES_SUCCESS,
  payload: data,
});

export const getCorporatesFailure = (error) => ({
  type: types.GET_CORPORATES_FAILURE,
  payload: error || "Failed to fetch corporates",
});

export const downloadTemplateRequest = (corporateId, rowCount) => ({
  type: types.DOWNLOAD_TEMPLATE_REQUEST,
  payload: { corporateId, rowCount },
});

export const downloadTemplateSuccess = () => ({
  type: types.DOWNLOAD_TEMPLATE_SUCCESS,
});

export const downloadTemplateFailure = (error) => ({
  type: types.DOWNLOAD_TEMPLATE_FAILURE,
  payload: error || "Failed to download template",
});

export const bulkUploadRequest = (corporateId, file, progress) => ({
  type: types.BULK_UPLOAD_REQUEST,
  payload: { corporateId, file, progress },
});

export const bulkUploadSuccess = (message) => ({
  type: types.BULK_UPLOAD_SUCCESS,
  payload: message || "Users created successfully",
});

export const bulkUploadFailure = (error) => ({
  type: types.BULK_UPLOAD_FAILURE,
  payload: error || { message: "Bulk upload failed" },
});


export const resetBulkUpload = () => ({
  type: types.RESET_BULK_UPLOAD,
});